import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Safety net globale: cattura le eccezioni di render (es. un errore che tenta di
// renderizzare un oggetto come figlio React) ed evita che l'intera app diventi bianca.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary ha catturato un errore:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  handleHome = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center bg-[#F7F7F5] p-6"
          data-testid="error-boundary-fallback"
        >
          <div className="max-w-md w-full bg-white rounded-2xl border border-[#DCDCDC] shadow-sm p-8 text-center">
            <div className="mx-auto mb-5 w-14 h-14 rounded-full bg-[#FFF0E5] flex items-center justify-center">
              <AlertTriangle className="w-7 h-7 text-[#FF7819]" />
            </div>
            <h1 className="text-xl font-bold text-[#3C3C3C] mb-2">
              Qualcosa è andato storto
            </h1>
            <p className="text-sm text-[#737373] mb-6">
              Si è verificato un errore imprevisto in questa pagina. I tuoi dati non sono stati persi.
              Ricarica la pagina per continuare.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleReload}
                className="px-4 py-2 rounded-lg bg-[#FF7819] text-white text-sm font-medium hover:bg-[#e56a12] transition-colors"
                data-testid="error-boundary-reload-btn"
              >
                Ricarica la pagina
              </button>
              <button
                onClick={this.handleHome}
                className="px-4 py-2 rounded-lg border border-[#DCDCDC] text-[#3C3C3C] text-sm font-medium hover:bg-gray-50 transition-colors"
                data-testid="error-boundary-home-btn"
              >
                Vai alla Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
